const resources = () => import('@/page/resources')

export default [
  {
    path: '/resources',
    name: 'resources',
    component: resources
  }
]



// WEBPACK FOOTER //
// ./src/router/resources/index.js